export const SEAC_CLIENT_CHOICE_INDEX = 2;

export function hasValidSeacClientChoice(cliente) {
  return (
    Array.isArray(cliente) &&
    cliente.length >= 5 &&
    Boolean(cliente[1]) &&
    [1, 2].includes(Number(cliente[SEAC_CLIENT_CHOICE_INDEX]))
  );
}

export function selectSeacAccountingType(clienti, scelta) {
  return clienti.map((cliente) => {
    const updated = [...cliente];
    updated[SEAC_CLIENT_CHOICE_INDEX] = scelta;
    return updated;
  });
}
